module.exports = __webpack_public_path__ + "img/Menu-15.7b5df0d7.png";